<template>
    <header class="header_zone p-r-20 p-l-20">
        <nav class="navbar navbar-expand-md p-t-4">
            <div class="container-fluid p-0">
                <router-link
                        :to="CONST_HOME_PATH"
                        custom v-slot="{ navigate }"
                >
                    <a
                            @click="navigate"
                            class="navbar-brand m-r-8 style_cursor"
                    >
                        <img src="../../assets/icons/logo.svg" alt="puzzlebot" width="31" height="36">
                        <span class="title_name_page">
                          <span class="css_StyleText18 fw-bold m-l-16">PuzzleBot</span>
                          <span class="css_StyleText18 fw-bold css_styleColor8 m-l-8">: //</span>
                        </span>
                    </a>
                </router-link>
                <div class="navbar-collapse">
                    <ul class="navbar-nav">

                        <router-link
                                :to="$route.path === CONST_ADMIN_PATH ? CONST_ADMIN_PATH : CONST_HOME_PATH"
                                custom v-slot="{ navigate }"
                        >
                            <li
                                    class="nav-item d-flex align-items-center style_cursor"
                                    @click="navigate"
                            >
                                <a class="nav-link reductionText css_StyleText2">
                                    <title-nav-bar></title-nav-bar>
                                </a>
                            </li>
                        </router-link>

                        <router-link
                                :to="`rubric?r=${$route.query.r}`"
                                custom v-slot="{ navigate }"
                                v-if="$route.path === CONST_RUBRIC_PATH || $route.path === CONST_ARTICLE_PATH"
                        >
                            <li
                                    class="nav-item d-flex align-items-center style_cursor"
                                    @click="navigate"
                            >
                                <span class="p-l-16 p-r-16 css_StyleText17">/</span>
                                <a class="nav-link reductionText css_StyleText18 css_link">{{nav_rubric_name}}</a>
                            </li>
                        </router-link>

                        <router-link
                                :to="`article?r=${$route.query.r}&a=${$route.query.a}`"
                                custom v-slot="{ navigate }"
                                v-if="$route.path === CONST_ARTICLE_PATH"
                        >
                            <li
                                    class="nav-item d-flex align-items-center style_cursor"
                                    @click="navigate"
                                    :title="nav_article_name"
                            >
                                <span class="p-l-16 p-r-16 css_StyleText17">/</span>
                                <a class="nav-link reductionText css_StyleText18 css_link">{{nav_article_name}}</a>
                            </li>
                        </router-link>

                    </ul>
                </div>

                <div class="inlineElements_sbs">
                  <button
                      @click="changeLanguage"
                      class="h30 css_vertical_center2 box_13 br-3 m-r-16 style_cursor p-l-8 p-r-8 css_StyleText12"
                      type="button"
                  >{{lang}}</button>
                  <a
                      href="https://cp.puzzlebot.top"
                      class="h30 css_StyleText10 css_styleBColor8 css_unfocus_links reductionText css_decoration_none mn-w-mx-ct-imt br-3 css_vertical_center2 p-l-16 p-r-16 style_cursor"
                  >
                    {{LS("Личный кабинет")}}
                  </a>
                </div>
            </div>
        </nav>
        <div
                v-if="$route.path !== CONST_ADMIN_PATH"
                class="d-flex justify-content-center"
        >
            <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                <div class="row">
                    <div class="css_pageTitle p-b-30 m-b-16 p-t-64">
                        <title-page></title-page>
                    </div>
                    <div
                            class="box_search_rubrics dropdown position-relative m-b-16"
                    >
                        <article-search
                                @goToFilteredArticlePage="goToFilteredArticlePage"
                        ></article-search>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
//import {  } from 'vue'
import { storeToRefs } from 'pinia'
import ArticleSearch from "./ArticleSearch";
import {
  CONST_RUBRIC_PATH,
  CONST_ARTICLE_PATH,
  CONST_ADMIN_PATH,
  CONST_HOME_PATH
} from "../constants/consts";
import {useClientStorage, useRubricArticleStore, useStatesStorage} from "../../stores/store";
import {loadLocale, LS} from "../services/translate";
import TitlePage from "./TitlePage";
import TitleNavBar from "./TitleNavBar";
import {ref} from "vue";
import {changeLanguageAJ} from "@/api/http";
import {useRoute} from "vue-router";
//import {useRouter} from "vue-router";

export default {
    props: {
        /*title_page: { type: String, required: true }*/
    },
    emits: [
        "goToFilteredArticlePage"
    ],
    setup(props, { emit }){
        //console.log('Header');
        //const router = useRouter();
        const route = useRoute();

        const statesStorage = useStatesStorage();
        const { viewStates } = storeToRefs(statesStorage);

        const clientStorage = useClientStorage();

        const lang = ref(clientStorage.clientObj.lang.toUpperCase());

        const rubricArticleStore = useRubricArticleStore();
        const { nav_rubric_name, nav_article_name, rubric_id, article_id } = storeToRefs(rubricArticleStore);

        //router.push('/') || router.push({name: home, params: {id: 1}, query: {r: 11}}) - переход к нужному роуту (к странице)
        //router.push({name: 'filtered-articles', query: {filter_text: filterArticlesObj.filter_text}})

        const changeLanguage = () => {
          const result_lang = lang.value.toLowerCase() == 'ru' ? 'en' : 'ru';
          changeLanguageAJ(result_lang).then(r => {
            if(r.ok)
            {
              return r.lang;
            }
            else
            {
              throw new Error(r.error);
            }
          }).then(lang => loadLocale(lang))
              .then(() => {
                  //router.push({name: '/article', query: {r: rubric_id.value, a: article_id.value}})
                if(route.path === CONST_RUBRIC_PATH) {
                  window.location = `?r=${rubric_id.value}`;
                }
                else if (route.path === CONST_ARTICLE_PATH) {
                  window.location = `?r=${rubric_id.value}&a=${article_id.value}`;
                }
                else {
                  window.location = ``;
                }

                //const instance = getCurrentInstance();
                //instance?.proxy?.$forceUpdate();
              })
              .catch((error) => {
                alert(error)
                return {resultInitView: false};
             });
        }

        const goToFilteredArticlePage = (new_filter_text) => {
            emit("goToFilteredArticlePage", new_filter_text)
        }

        return {
            viewStates,
            CONST_RUBRIC_PATH,
            CONST_ARTICLE_PATH,
            CONST_HOME_PATH,
            CONST_ADMIN_PATH,
            nav_rubric_name,
            nav_article_name,
            goToFilteredArticlePage,
            LS,
            lang,
            changeLanguage
        }
    },
    components: {TitlePage, TitleNavBar, ArticleSearch}
}
</script>

<style scoped>
    .header_zone .navbar{
        max-height: 68px;
        height: 68px;
    }

    .header_zone .navbar .navbar-nav .nav-link{
      max-width: 100%;
    }

    .header_zone .navbar .navbar-nav .nav-item{
      max-width: 17vw;
    }


    @media (max-width: 1199px) {
        .header_zone .navbar{
            /*max-height: unset !important;
            height: unset !important; */
        }
    }

    @media (max-width: 767px) {
      .header_zone .navbar .navbar-nav{
        display: none;
      }

      .header_zone .navbar-collapse{
        display: flex!important;
        flex-basis: auto !important;
      }
    }

    @media (max-width: 404px) {
      .header_zone .navbar .navbar-brand .title_name_page{
        display: none;
      }
    }
</style>